export const Configs = {
	BearerToken: process.env.REACT_APP_BEARER_TOKEN,
	urlApi: process.env.REACT_APP_API_URL,
	typeApi: process.env.REACT_APP_TYPE_API,
	pays: [
		{
			key: 'FR',
			value: 'France',
			url: 'https://www.musiconline-france.art',
			home: '7adda671-7b99-4b2d-ae7e-405bc61ae3c1'
		},
		{
			key: 'CH',
			value: 'Suisse',
			url: 'https://www.musiconline-suisse.art',
			home: ''
		}
	],
	statutTremplin: [
		{
			key: 0,
			value: 'Inactif'
		},
		{
			key: 1,
			value: 'Actif'
		},
		{
			key: 2,
			value: 'Terminé'
		},
		{
			key: 3,
			value: 'Clôturé'
		}
	],
	statutCandidat: [
		{
			key: 0,
			value: 'En attente'
		},
		{
			key: 1,
			value: 'Candidature acceptée'
		},
		{
			key: 2,
			value: 'Candidature refusée'
		}
	],
	destinataires: [
		{
			value: 'Utilisateurs'
		},
		{
			value: 'Annuaire Pro'
		},
		{
			value: 'Annuaire Musiciens'
		},
		{
			value: 'Liste de test'
		}
	]
};
